<template>
	<div class="card mt-4">
		<div :class="'card-header ' + bg">
			<div class="d-flex align-items-center flex-wrap">
				<h3 class="mb-0 mr-3">
					<i v-if="icon" :class="'fa fa-' + icon"></i>
					{{ title }}
				</h3>
				<div class="d-flex align-items-center ml-auto">
					<slot name="titleBadge"></slot>
					<div class="text-right ml-2">
						<button v-if="id && History" class="btn btn-secondary mr-2" title="Mostrar Historial" type="button"
							@click="showHistory">
							<i aria-hidden="true" class="fas fa-clock" style="font-size: 14px"></i>
							Mostrar Historial
						</button>
						<button v-if="id && exportXlsx" class="btn btn-success"  title="Exportar XLSX" type="button"
							@click="exportRequest">
							<i aria-hidden="true" class="fas fa-file-excel" style="font-size: 14px"></i>
							Exportar XLSX
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="card-body">
			<div v-if="isAdmin ||
				isCommercial ||
				isMainCommercial ||
				isCommercialDispatcher ||
				isOenology
				">
				<router-link v-if="createUrlButton" :to="createUrlButton" class="btn btn-success"
					title="Registrar Nueva Solictud">
					<i class="fa fa-plus"></i>
					Nueva Solicitud
				</router-link>
			</div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
//import internal from 'stream';

export default {
	name: "Card",
	props: {
		title: {
			type: String,
			required: false,
		},
		icon: {
			type: String,
			required: false,
		},
		createUrlButton: {
			type: String,
			required: false,
		},
		bg: {
			type: String,
			required: false,
			default: "",
		},
		id: {
			type: String,
			required: false,
		},
		exportXlsx: {
			type: Boolean,
			required: false,
			default: false,
		},
		History: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			isAdmin: this.$store.getters.isAdmin,
			isDispatch: this.$store.getters.isDispatch,
			isCommercial: this.$store.getters.isCommercial,
			isMainCommercial: this.$store.getters.isMainCommercial,
			isCommercialDispatcher: this.$store.getters.isCommercialDispatcher,
			isOenology: this.$store.getters.isOenology,
		};
	},
	methods: {
		showCloneModal() {
			this.$emit("showCloneModal", true);
		},
		exportRequest() {
			this.$emit("exportRequest", true);
		},
		showHistory() {
			this.$emit("showHistory", true);
		},
	},
};
</script>
